// The Team filter is the one control in the row whose content varies
// (a name per selection), so it can't share a fixed width with Projects/
// Leads/Events/Reminders — but `flex: 1`/`width: 100%` (the first fix for
// "+1 hides who's selected") went the other way: an empty selector stretched
// across nearly the whole remaining header width. Neither a fixed width nor
// an unbounded one is right; the width has to track what's actually selected,
// between a floor (so the empty "Team" placeholder isn't cramped) and a
// ceiling (so it never dominates the row the way `flex: 1` did) — beyond
// that ceiling, antd's own multi-select tag wrapping takes over instead of
// growing the box further.
const BASE_WIDTH_PX = 160
const WIDTH_PER_MEMBER_PX = 70
const MAX_WIDTH_PX = 420

export function teamFilterWidthPx(selectedCount: number): number {
  if (!selectedCount || selectedCount <= 0) return BASE_WIDTH_PX
  return Math.min(BASE_WIDTH_PX + selectedCount * WIDTH_PER_MEMBER_PX, MAX_WIDTH_PX)
}
